import { toast } from 'sonner'

/** Accept legacy (enqueueSnackbar, message) or (message). */
function resolveMessage(a, b) {
  if (b !== undefined) return b
  return a
}

/**
 * Info toast — legacy enqueueSnackbar arg ignored.
 * Call: showInfoSnackbar(message) or showInfoSnackbar(_, message)
 */
export default function showInfoSnackbar(a, b) {
  const message = resolveMessage(a, b)
  if (!message) return
  toast.info(String(message), { duration: 3500 })
}
